import React, { useState, useEffect, Fragment } from "react";
import { Box, Button, Typography, Grid, MenuItem, Stack } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams, useOutletContext } from "react-router-dom";
import MpgInput from "../../../../../CommonFormComp/MpgInput";
import MpgItem from "../../../../../CommonFormComp/MpgItem";
import MpgFileUpload from "../../../../../fileHandling/MpgFileUpload";
import { saveAs } from "file-saver";
import MuiLink from '@mui/material/Link';
import { editProgrammeDescriptorValidation } from "./editProgrammeDescriptorValidation";
import { managePDViewPath } from "../../../../../routes/routePaths";
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";
import MpgLoadingDialog from "../../../../../common/dialog/MpgLoadingDialog";
import { useGetLoggedInUserDetails } from "../../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import { useUpdateProgramDescriptorMutation, useUploadProgramDescriptorFileMutation, useViewProgrammeDescriptorListMutation } from "../../../../../reactQueries/AppApi/rqHooksForProgrammeDescriptor";
import { useFileDownloadMutation } from "../../../../../reactQueries/commonRQHooks";
import useTrackUserActivity from "../../../../../userActivityTracking/useTrackUserActivity";
import { getGUIDAndExtentionFromFileURL } from "../../../../../hooksAndFunctions/functions/getGUIDAndExtentionFromFileURL";
import { getAccessTypes } from "../../../../../hooksAndFunctions/functions/getAccessTypes";
import FormHelperText from '@mui/material/FormHelperText';

const EditProgrammeDescriptor = ({ programDescriptorById }) => {
  const { id: programDescriptorId } = useParams()

  const navigate = useNavigate();

  const { loggedInUser } = useGetLoggedInUserDetails();
  const { emailAddress, clientPortalAdminRoleId, isEnterpriseAdmin, id: userId } = loggedInUser;

  const {
    clientPortalAdminType
  } = getAccessTypes()
  const {
    isClientPortalAdmin,
    hasA4Access
  } = clientPortalAdminType

  /** !!!!!!!! form handling  !!!!!!!! */

  const { schema } = editProgrammeDescriptorValidation();

  const rhfFormInstance = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      pdTitle: programDescriptorById?.ProgramDescripitorTitle || ""
    }
  });

  const { watch, setValue, trigger } = rhfFormInstance;

  const inputPDTitle = watch("pdTitle")

  /** !!!!!!!! API calls  !!!!!!!! */
  const { mutate: getPDList, isSuccess, error, data: PDData, isError, isLoading: isLoadingOnPDData, } = useViewProgrammeDescriptorListMutation();

  useEffect(() => {
    getPDList({ loggedInUserId: userId, roleId: clientPortalAdminRoleId, isEnterpriseAdmin })
  }, [loggedInUser])

  let filteredPDListForStandardType = !!PDData?.data && PDData?.data.filter((eachItem) => eachItem?.ProgramDescripitorType === "Standard")

  /**file download api */
  const { mutate: DownloadPDfile, isError: isErrorOnDownload, isLoading: isLoadingOnDownload, isSuccess: isSuccessOnDownload, data: dataOnDownload, error: errorOnDownload } = useFileDownloadMutation()


  // api - create report resource mutation
  const {
    mutate: updateProgramDescriptor,
    isError: isErrorOnUpdate,
    isLoading: isLoadingOnUpdate,
    isSuccess: isSuccessOnUpdate,
    data: dataOnUpdate,
    error: errorOnUpdate,
  } = useUpdateProgramDescriptorMutation();

  const {
    mutate: uploadPDFile,
    isError: isErrorOnPDFileUpload,
    isLoading: isLoadingOnPDFileUpload,
    isSuccess: isSuccessOnPDFileUpload,
    data: dataOnPDFileUpload,
    error: errorOnPDFileUpload,
  } = useUploadProgramDescriptorFileMutation();


  /**handling and processing for file download */
  const [fileDetails, setFileDetails] = useState({})

  useEffect(() => {
    if (!!programDescriptorById?.ProgramDescripitorFileName) {
      setFileDetails({
        ProgramDescripitorFileName: programDescriptorById?.ProgramDescripitorFileName || "",
        ProgramDescripitorFileGuid: programDescriptorById?.ProgramDescripitorFileGuid || "",
        ProgramDescripitorFileSize: programDescriptorById?.ProgramDescripitorFileSize || "",
      })
    } else {
      setFileDetails({})
    }
  }, [programDescriptorById?.ProgramDescripitorFileName])

  /** !!!!!!!! handling submit function  !!!!!!!! */
  const [bodyDataForUpdate, setBodyDataForUpdate] = useState({});
  const onSubmit = (data) => {
    const body = {
      Id: programDescriptorById?.Id,
      ProgramDescripitorTitle: data?.pdTitle || "",
      ProgramDescripitorType: "Standard",
      IsActive: programDescriptorById?.IsActive,
      UpdatedBy: emailAddress || "",
      ProgramDescripitorURL: programDescriptorById?.ProgramDescripitorURL || "",
      ProgramDescripitorFileName: programDescriptorById?.ProgramDescripitorFileName || "",
      ProgramDescripitorFileGuid: programDescriptorById?.ProgramDescripitorFileGuid || "",
      ProgramDescripitorFileSize: programDescriptorById?.ProgramDescripitorFileSize || "",
    };
    setBodyDataForUpdate(body);

    if (!!data.pdFile[0]) {
      const file = data.pdFile[0];

      const bodyData = {
        ...body,
        ProgramDescripitorFileName: file.name || "",
        ProgramDescripitorFileSize: file.size || "",
      };
      setBodyDataForUpdate(bodyData);

      uploadPDFile({ file });
    } else {
      updateProgramDescriptor({ body, programDescriptorId });
    }
  };

  const resourcesCMSData = useOutletContext();

  const fetchMngResoRepoDtlsLabel = (key) => {
    if (resourcesCMSData && resourcesCMSData?.pageContent["ManageResourceRepoDetails"]) {
      const resourcesCMSDataLabel = resourcesCMSData.pageContent["ManageResourceRepoDetails"];
      return returnLabel(resourcesCMSDataLabel?.Labels, key)
    }
  }

  const returnLabel = (labelArray, key) => {
    if (labelArray.length > 0 && key) {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }
    return '';
  }

  useEffect(() => {
    if (!!dataOnPDFileUpload?.data?.IsSuccess) {
      const storedFileURL = dataOnPDFileUpload.data.ProgramDescripitorURL;
      const fileGuid = dataOnPDFileUpload.data.Id;
      /**merging file URL to body */
      const bodyData = {
        ...bodyDataForUpdate,
        ProgramDescripitorURL: storedFileURL,
        ProgramDescripitorFileGuid: fileGuid
      };
      updateProgramDescriptor({ body: bodyData, programDescriptorId });
    }
  }, [dataOnPDFileUpload?.data?.IsSuccess]);

  useEffect(() => {
    if (!!isSuccessOnUpdate) {
      navigate(managePDViewPath);
    }
  }, [isSuccessOnUpdate]);

  /** file download handling  */
  useEffect(() => {
    if (!!isSuccessOnDownload) {
      saveAs(dataOnDownload, `${programDescriptorById?.ProgramDescripitorFileName}`);
    }
  }, [isSuccessOnDownload])

  /**
   * disable update button
   */
  const [disabledUpdateButton, setDisabledUpdateButton] = useState(false)
  useEffect(() => {
    if (!programDescriptorById?.IsActive) {
      setDisabledUpdateButton(true)
    } else if (!!hasA4Access) {
      setDisabledUpdateButton(true)
    } else {
      setDisabledUpdateButton(false)
    }

  }, [programDescriptorById, hasA4Access])

  /**only Standard PD title validation  */
  let arrayOfOnlyStandardPDTitles = []
  !!filteredPDListForStandardType && filteredPDListForStandardType.forEach((eachItem) => {
    if (eachItem?.Id !== programDescriptorById?.Id) {
      arrayOfOnlyStandardPDTitles.push(eachItem?.ProgramDescripitorTitle)
    }
  })
  const [standardPDTitleFieldErrorMsg, setStandardPDTitleFieldErrorMsg] = useState("")
  useEffect(() => {
    if (!!arrayOfOnlyStandardPDTitles.includes(inputPDTitle?.trim())) {
      const msg = "This standard resource title already exists in records."
      setStandardPDTitleFieldErrorMsg(msg)
    }
    else {
      setStandardPDTitleFieldErrorMsg("")
    }
  }, [arrayOfOnlyStandardPDTitles, inputPDTitle])

  /**tracking user Activity */
  const { trackActivity } = useTrackUserActivity()
  useEffect(() => {
    if (!!isSuccessOnDownload) {
      trackActivity({
        activitySuccess: !!isSuccessOnDownload,
        actionType: "Downloaded",
        itemId: fileDetails?.ProgramDescripitorFileGuid || "",
      })
    }
    if (!!isSuccessOnPDFileUpload) {
      const { fileGUID } = getGUIDAndExtentionFromFileURL({ fileURL: dataOnPDFileUpload?.data?.FileUrl })

      trackActivity({
        activitySuccess: !!isSuccessOnPDFileUpload,
        actionType: "Uploaded",
        itemId: fileGUID || "",
      })
    }
  }, [isSuccessOnDownload, isSuccessOnPDFileUpload])

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h5" align="center" sx={{ fontWeight: "bolder" }}>
        {/* Update Standard Resource */}
        {fetchMngResoRepoDtlsLabel('ManageResourceRepoDetails.UpdateStandardResource')}
      </Typography>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        m={1}
      >
        <Button
          variant="outlined"
          size="small"
          component={Link}
          to={managePDViewPath}
        >
          {/* Resources */}
          {fetchMngResoRepoDtlsLabel('ManageResourceRepoDetails.Resources')}
        </Button>
      </Stack>


      <Box
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={rhfFormInstance.handleSubmit(onSubmit)}
      >

        <MpgItem>
          <MpgInput
            rhfFormInstance={rhfFormInstance}
            name={"pdTitle"}
            label={fetchMngResoRepoDtlsLabel('ManageResourceRepoDetails.StandardResourceTitle')}//"Standard Resource Title"
            fullWidth
          />
          {
            <FormHelperText error={!!standardPDTitleFieldErrorMsg}>
              {standardPDTitleFieldErrorMsg}
            </FormHelperText>
          }

          <Grid item xs={12}>
            <MpgFileUpload
              name="pdFile"
              label= {fetchMngResoRepoDtlsLabel('ManageResourceRepoDetails.UploadFile')} //"Upload file"
              rhfFormInstance={rhfFormInstance}
              persistantMsg={fetchMngResoRepoDtlsLabel('ManageResourceRepoDetails.AllowedFile')} //`Only pdf/ppt file type is allowed`
            />
            { /** file download func */}
            {
              !!programDescriptorById?.ProgramDescripitorFileName && (
                <MuiLink
                  onClick={() => {
                    const fileName = fileDetails?.ProgramDescripitorFileName
                    const fileNameSplit = fileName.split('.')
                    const fileExtension = fileNameSplit.at(-1)

                    if (!!fileDetails?.ProgramDescripitorFileGuid) {
                      DownloadPDfile({
                        fileGUID: fileDetails?.ProgramDescripitorFileGuid,

                        /**DownloadType: "profileImage"|"logo"|"reportAndResources"|"programDescriptor" */
                        DownloadType: "programDescriptor",
                        Extension: fileExtension
                      })
                    }
                  }}
                >
                  {`${programDescriptorById?.ProgramDescripitorFileName}`}
                </MuiLink>
              )
            }

          </Grid>
        </MpgItem>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-evenly"}
          mt={3}
        >
          <Button
            variant="outlined"
            type="submit"
            size="small"
            disabled={!!disabledUpdateButton || !!standardPDTitleFieldErrorMsg}
          >
            {/* Update Programme descriptor */}
            {fetchMngResoRepoDtlsLabel('ManageResourceRepoDetails.UpdateProgrammeDescriptor')}
          </Button>
        </Stack>
      </Box>

      {/** error dialog on create action */}
      <MpgErrorDialog
        open={!!isErrorOnUpdate || !!isErrorOnPDFileUpload || !!isErrorOnDownload}
        title={errorOnPDFileUpload?.response
          ?.data?.ErrorCode === "104" && fetchMngResoRepoDtlsLabel('ManageResourceRepoDetails.ErrorMsgFileScanFailed')} //"Opps, file scanning failed...!"
      />
      <MpgLoadingDialog
        open={
          !!isLoadingOnUpdate ||
          !!isLoadingOnPDFileUpload
        }
      />
    </Box>
  );
};

export default EditProgrammeDescriptor;
